module.exports = __webpack_public_path__ + "static/media/csite-bg.a8ffe92a.jpg";